import React from 'react'

const ViewPurchasedOrder = () => {
  return (
    <div className='mx-auto p-4'>
      <h4 className='font-semibold my-4'>Procurement <span className='text-[#0E6F1E]'>> Purchased Order</span></h4>

      <div className="bg-white p-4 my-4">
        <div className="text-center space-y-4">
          <h5><b>All requested items in this order is perfect and completed?</b></h5>
          <div className="flex items-center justify-center gap-2">
            <button className='px-5 py-1 rounded-lg text-white bg-green-600'>Yes</button>
            <button className='px-5 py-1 rounded-lg text-white bg-red-600'>No</button>
          </div>
        </div>
        <br />
        <hr />

        <div className='flex items-center justify-around my-4'>
          <div className='space-y-4'>
            <div className='flex items-center space-x-6'>
              <h5 className='font-semibold text-[#192252]'>Order Number:</h5>
              <p className='float-left'>Maimoon</p>
            </div>
            <div className='flex items-center space-x-6'>
              <h5 className='font-semibold text-[#192252]'>Vendor Name:</h5>
              <p className='float-left'>25</p>
            </div>
          </div>
          <div className='space-y-4'>
            <div className='flex items-center space-x-6'>
              <h5 className='font-semibold text-[#192252]'>Date and Time:</h5>
              <p className='float-left'>Maimoon</p>
            </div>
            <div className='flex items-center space-x-6'>
              <h5 className='font-semibold text-[#192252]'>Last Name:</h5>
              <p className='float-left'>25</p>
            </div>
          </div>
        </div>

        <br />
        <hr />
        <br />


        <div className="flex gap-4">
          <h5>Description:</h5>
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Natus repudiandae hic ullam sunt at! 
            Sapiente officiis natus quia fuga quis, ipsum, sit, animi voluptate quaerat quasi doloribus 
            Sapiente officiis natus quia fuga quis, ipsum, sit, animi voluptate quaerat quasi doloribus 
            Sapiente officiis natus quia fuga quis, ipsum, sit, animi voluptate quaerat quasi doloribus 
            assumenda! Necessitatibus, doloremque?
          </p>
        </div>
      </div>
    </div>
  )
}

export default ViewPurchasedOrder
